export const getOffsetQueryString = (offset: number) => `offset=${offset}`;
